/**
 * Various modals required by the mapping module
 */
angular.module("routes:mapping").factory("MappingModals", function ($uibModal, $stateParams, Session) {
  return {
    /**
     * Open the "save map" modal
     * TODO: move this to the new react map modal
     * @param  {Object} map
     * @param  {Function} save Function to call on save
     * @param  {map[]} parents An optional list of map objects which could be parents to this the one being saved.
     * @param  {string} saveAs An alternate name to give the map
     * @return {Promise}
     */
    openSaveMap(map, save, parents, saveAs) {
      // Clone it so the original isn't modified
      map = angular.copy(map);

      // By default, the new map's parent will be old map or the old map's parent, if set.
      map.parentID = map.parentID || map.ID;

      if (saveAs) map.name = saveAs;

      // Create the modal
      let modal = $uibModal.open({
        template: `<epi-edit-map-form map="map" parents="parents" on-save="save" on-cancel="$dismiss" parent-change-allowed="true" is-creating="true"></epi-edit-map-form>`,
        windowClass: "truterritory-save-map",
        controller: function ($scope, $uibModalInstance) {

          $scope.map = map;
          $scope.parents = parents;

          $scope.save = function (map) {
            save(map).then($uibModalInstance.close);
          };
        },
      });

      return modal.result;
    },

    /**
     * Open the "map has unsaved changes" modal
     * @param {string} msg
     * @return {Promise}
     */
    openSaveMapChanges(msg, save, saveText = "Save", cancelText = "Cancel") {
      let modal = $uibModal.open({
        templateUrl: "mapping/unsaved-changes-modal.html",
        controller: function ($scope, $uibModalInstance) {
          $scope.msg = msg;
          $scope.saving = false;
          $scope.saveText = saveText;
          $scope.cancelText = cancelText;
          $scope.save = function () {
            $scope.saving = true;
            save().then($uibModalInstance.close);
          };
          $scope.$on("enter", $scope.save);
        },
      });

      return modal.result;
    },

    /**
     * Open the "save workspace" modal
     * TODO: move this to the new react workspace modal;
     *   the only place this is still used is in the layers panel to add a workspace
     * @param  {Object} workspace
     * @param  {Function} save Function to call on save
     * @param  {string} saveAs An alternate name to give the workspace
     * @return {Promise}
     */
    openSaveWorkspace(workspace, save, saveAs) {
      // Clone it so the original isn't modified
      workspace = "clone" in workspace ? workspace.clone() : angular.copy(workspace);

      if (saveAs) workspace.name = saveAs;

      // Create the modal
      let modal = $uibModal.open({
        templateUrl: "mapping/save-workspace-modal.html",
        windowClass: "save-new-workspace",
        controller: function ($scope, $uibModalInstance) {
          $scope.workspace = workspace;
          $scope.saving = false;

          $scope.save = function () {
            $scope.saving = true;
            let form = $scope.validateForm("newWorkspace");
            if (form.isValid()) save(workspace).then($uibModalInstance.close);
          };
        },
      });

      return modal.result;
    },

    /**
     * Opens a modal containing the link
     * @param  {object} map
     * @return {void}
     */
    openPermalink(map, truMap) {
      // Create a new modal
      var permalinkModal = $uibModal.open({
        templateUrl: "mapping/get-permalink-modal.html",
        windowClass: "truterritory-save-permalink-modal",
        controllerAs: "modal",
        bindToController: true,
        controller: function ($scope, $http, API_ROOT, SHARING_ROOT, hasMapAccess) {
          this.map = map;
          this.hasAccess = hasMapAccess;
          this.saving = false;
          this.confirming = false;
          this.useCenterZoom = false;
          this.showAnnotations = false;
          this.annotationOption = null;
          this.requirePassword = !!map.password;
          this.oldPassword = map.password;
          this.generating = false;
          this.expires = false;
          this.expiresAt = null;
          this.oldExpiresAt = null;
          this.expiringUUID = null;
          this.datepickerOptions = {
            "show-weeks": false,
            minDate: moment().add(1, "days"),
            maxDate: moment().add(90, "days"),
          };

          // Create a URL from the map's UUID
          this.generateLink = function () {
            let uuid = this.expires ? this.expiringUUID : map.UUID;
            let link = SHARING_ROOT + "/" + uuid;
            let params = {};

            if (this.showAnnotations) {
              // If we don't have the hashed value to put in the URL, get it and try again.
              if (!this.annotationsOption) {
                this.map.getAnnotationsOption().then((option) => {
                  this.annotationsOption = option;
                  this.generateLink();
                });
                return;
              }

              params["o"] = this.annotationsOption;
            }

            if (this.useCenterZoom) {
              let { lat, lng } = truMap.getCenter();
              Object.assign(params, {
                lat,
                lng,
                zoom: truMap.getZoom(),
              });
            }

            if (Object.keys(params).length) link += `?${$.param(params)}`;

            this.link = link;
          };

          // Tell the server to create a new UUID
          this.reset = function () {
            this.saving = true;
            map.getNewUUID().then((uuid) => {
              this.saving = this.confirming = this.expires = false;
              this.expiringUUID = this.expiresAt = null;
              this.generateLink();
            });
          };

          // Retrieve a temporary, expiring UUID
          this.getExpiringUUID = function (expiresAt) {
            this.expiringUUID = null;
            map.getExpiringUUID(expiresAt).then((uuid) => {
              this.expiringUUID = uuid;
              this.generateLink();
            });
          };

          // Set a new password
          this.setPassword = function () {
            if (!this.requirePassword) map.password = null;
            if (map.password === "") {
              this.requirePassword = false;
              map.password = null;
            }

            this.oldPassword = map.password;
            map.patch({ password: map.password });
          };

          // Generate a password
          this.generatePassword = function () {
            this.generating = true;

            $http.get(API_ROOT + "/phrase").then((response) => {
              this.oldPassword = map.password;
              map.password = response.data.data;
              this.generating = false;
            });
          };

          // Set the expiration date
          this.setExpiresAt = function () {
            if (!this.expires) {
              this.expiringUUID = this.expiresAt = null;
              this.generateLink();
            }

            if (this.expiresAt === "") {
              this.expires = false;
              this.expiresAt = null;
            }

            if (this.expiresAt && $scope.expiresForm.$valid && this.expiresAt != this.oldExpiresAt) this.getExpiringUUID(this.expiresAt);
          };

          this.generateLink();
        },
      });
    },

    /**
     * Accept a password
     * @param {bool} first Message changes after the first time showing the modal.
     * @return {Promise}
     */
    openPassword(first = true) {
      let modal = $uibModal.open({
        backdrop: "static",
        keyboard: false,
        windowClass: "mapping-password",
        templateUrl: "mapping/password-modal.html",
        controller: function ($scope) {
          $scope.first = first;
        },
      });

      return modal.result;
    },
  };
});
